import { detalheSolicitacao } from '@/components/TemplateSolicitacao/componentes/RegrasDeNegocio'
import moment from 'moment/moment'

const preloadWidgetDefault = async (row, funcionalidade, authorization, aplicacao) => {
  const detalhe = await detalheSolicitacao(funcionalidade.idFuncionalidade, row.id_ocorrencia)
  return createPayload(detalhe, funcionalidade, authorization, aplicacao)
}

const parseDate = (value) => {
  if (!value) {
    return '-'
  }
  if ((/\d{4}-\d{2}-\d{2}/).test(value)) {
    return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }
  try {
    return moment(Number.parseInt(value)).format('DD/MM/YYYY')
  } catch (ignored) {
    return moment(value).format('DD/MM/YYYY')
  }
}

function createPayload (detalhe, funcionalidade, authorization, aplicacao) {
  const payload = {
    'idFuncionalidade': funcionalidade.idFuncionalidade,
    'data': {
      ...detalhe
    },
    'configuracao': {
      'parametros': {},
      'metodoEnvio': []
    },
    'opcoesDeEnvio': []
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 1,
        'descricao': 'Mensagem no chat'
      },
      'sincrono': true
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 2,
        'descricao': 'E-mail'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget,
      'sincrono': false
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 3,
        'descricao': 'WhatsApp'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget,
      'sincrono': false
    })
  }
  payload.opcoesDeEnvio.push({
    'nome': funcionalidade.nome,
    'nomeIntegracao': 'detalheSolicitacao',
    'integracao': {
      'headers': {
        'Authorization': authorization,
        'id_funcionalidade': funcionalidade.idFuncionalidade,
        'id_ocorrencia': detalhe.id_ocorrencia,
        'mshash': aplicacao.mshash
      },
      'parametros': {},
      'rota': {
        contentType: 'application/json',
        metodo: 'GET',
        path: '/solicitacao/detalhe',
        urlBase: 'ocorrencia'
      },
      'payload': {}
    },
    'data': {
      'tituloWidget': `${funcionalidade.nome}`,
      'textoWidget': `Solicitacao criada em: ${(detalhe.guia) ? parseDate(detalhe.guia.dataSolicitacao) : parseDate(detalhe.data_registro)}, sob o numero de protocolo: ${(detalhe.numeroProtocolo) ? detalhe.numeroProtocolo : detalhe.protocolo} com status de "${(detalhe.situacao) ? detalhe.situacao.descricao : detalhe.status_label}"`,
      ...detalhe,
      ...detalhe.guia
    }
  })
  return payload
}
export { preloadWidgetDefault }
